/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import React from "react";

import { DetailWrapper } from "Containers/Common/CommonContainer.styles";

/**
 * Page not found Container.
 * Container for page not found.
 * @returns {React.ReactElement} rendered container
 */
const PageNotFoundContainer = (): React.ReactElement => {
  return <DetailWrapper>Page not found</DetailWrapper>;
};

export default PageNotFoundContainer;
